import React from "react";
import Page from "./pages/Page";
import Data from "./utils/kerckoffdata";

export default class App extends React.Component<{}, { data: any }> {
  constructor(props) {
    super(props);
    this.state = {
      data: null
    };
  }

  async componentDidMount() {
    await this.setState({
      data: await Data
    });
  }

  render() {
    return <>{this.state.data && <Page {...this.state}></Page>}</>;
  }
}
